import './style.less';
import { merge } from 'lodash';

export default function(AuthClass, ProfileClass, VendorClass, $transitions) {
  'ngInject';

  const vm = this;

  vm.$onChanges = onChanges;

  let loggedIn = ProfileClass.loggedIn;
  let company_id = 1;

  function setVendorInfo({ name }, { vendor_id }) {
    if (!name.includes('vendor') || !vendor_id) {
      vm.vendorPath = false;
      company_id = 1;
      return;
    }

    vm.vendorPath = true;

    VendorClass.loadVendors()
      .then(({ obj }) => {
        company_id = VendorClass.convertUser(vendor_id);
      })
      .catch(error => {
        company_id = 1;
        throw error;
      });
  }

  $transitions.onSuccess({}, function(trans) {
    const currentPath = trans.to();
    const currentPathParams = trans.params();
    loggedIn = ProfileClass.loggedIn;

    setVendorInfo(currentPath, currentPathParams);
  });

  function buildError(status, text) {
    let error;
    switch (status) {
      case 403:
        error = {
          action: () => AuthClass.authenticationPopup({ company_id }), //open login for not logged in users;
          onInit: function() {
            this.action();
          },
          body: 'The resource you were trying to reach is forbidden',
          button: true,
          buttonText: 'Sign In / Sign Up',
          reloadDisable: loggedIn,
          title: 'Forbidden'
        };
        break;
      case 404:
        error = {
          body: 'The resource you were trying to reach is missing',
          button: true,
          title: 'Missing',
          reloadDisable: true
        };
        break;
      case 410:
        error = {
          body: 'The resource you were trying to reach is archived',
          button: true,
          title: 'Archived',
          reloadDisable: true
        };
        break;
      case 424:
        error = { body: text, button: true, title: 'Failed Dependency', reloadDisable: true };
        break;
      case 'No Content':
        error = { body: text, button: true, title: 'No Content', reloadDisable: true };
        break;
      case 'Webinar Error':
        error = {
          body:
            'Click the “Retry” button below to reconnect your session. If you are still experiencing this error, please contact us at support@prolaera.com',
          button: true,
          buttonText: 'Retry',
          title: 'Integration Error',
          reload: () => {
            vm.error.refresh();
          }
        };
        break;
      case 'Auth Error':
        error = {
          body:
            'Click the “Retry” button below to reconnect your session. If you are still experiencing this error, please contact us at support@prolaera.com',
          button: true,
          buttonText: 'ReAuth',
          title: 'Auth Error',
          reload: () => {
            vm.error.redirect();
          }
        };
        break;
      default:
        error = {
          body: 'Please click below to reload',
          button: true,
          buttonText: 'Reload',
          count: 0,
          maxReloads: 2,
          title: 'Error',
          reload: () => {
            vm.error.count++;
            vm.error.refresh();
          }
        };
        break;
    }
    return error;
  }

  function onChanges() {
    if (vm.error) vm.error = merge(buildError(vm.error.status, vm.error.text), vm.error);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/componentHandler/controller.js